import * as $ from 'jquery';
import 'slick-carousel';

class CompareManager {
	private static instance: CompareManager;
	private static cookie_name: string = 'compared_properties';

	private static comparisonCheckboxSelector = '.propertyCard .item__compare input[type="checkbox"]';

	private slickOptions: JQuerySlickOptions = {
		slidesToShow: 3,
		slidesToScroll: 1,
		autoplay: false,
		autoplaySpeed: 5000,
		arrows: true,
		dots: false,
		pauseOnHover: false,
		infinite: false,
		responsive: [
			{breakpoint: 1300, settings: {slidesToShow: 2}},
			{breakpoint: 1000, settings: {slidesToShow: 1}}
		]
	};

	public constructor() {
		if (CompareManager.instance) {
			return CompareManager.instance;
		}
		CompareManager.instance = this;
	}

	init() {
		if (!document.querySelector('.comparisonBar')) {
			return;
		}

		this.onReady = this.onReady.bind(this);
		if (document.readyState === "interactive" || document.readyState === "complete") {
			this.onReady();
		} else {
			document.addEventListener("DOMContentLoaded", this.onReady);
		}
	}

	private onReady() {
		const $comparisonListingInner = $('.comparisonListing__inner');
		$comparisonListingInner.slick(this.slickOptions);
		// Slick doesn't properly calculate sizes when you have too few elements in a flexible container, so... we do this.
		$comparisonListingInner.on('setPosition', () => {
			const comparedProperties = this.getComparedProperties();
			if (comparedProperties.length < 3) {
				(document.querySelector('.comparisonListing__inner .slick-track') as HTMLElement).style.width = null;
				const slickSlides = document.querySelectorAll('.comparisonListing__inner .slick-track .slick-slide');
				for (let i = 0; i < slickSlides.length; i++) {
					(slickSlides.item(i) as HTMLElement).style.width = null;
				}
			}
		});

		const comparedPropertiesStore: HTMLInputElement = document.querySelector('input.comparedPropertiesStore');
		if (comparedPropertiesStore !== null && comparedPropertiesStore.value !== null && comparedPropertiesStore.value.length > 0) {
			this.setComparedProperties(comparedPropertiesStore.value.split(','));
		}
		this.onComparedPropertiesChange();

		$(document).on('change', CompareManager.comparisonCheckboxSelector, event => {
			const target: HTMLElement = event.target;
			const propertyId: string = $(target).parents('.propertyCard').data('property-id');
			if ((target as HTMLInputElement).checked) {
				this.addComparedProperty(propertyId);
			} else {
				this.removeComparedProperty(propertyId);
			}
		});
		$(document).on('click', '.removeComparedProperty', event => {
			this.removeComparedProperty(event.target.getAttribute('data-property-id'));
		});

		$('.clearComparisonList').on('click', event => {
			event.preventDefault();
			if (confirm('Do you want to clear the comparison list?')) {
				this.setComparedProperties([]);
			}
			return false;
		});
		document.addEventListener('jsfAjaxEvent', event => {
			if ((event as any).detail.fireType === 'always') {
				this.onComparedPropertiesChange();
			}
		});
	}

	public getComparedProperties(): string[] {
		const comparedPropertiesString = window.sessionStorage.getItem(CompareManager.cookie_name);
		return !comparedPropertiesString ? [] : comparedPropertiesString.split(',');
	}
	public getComparedPropertiesRaw(): string {
		const comparedPropertiesString = window.sessionStorage.getItem(CompareManager.cookie_name);
		return !comparedPropertiesString ? '' : comparedPropertiesString;
	}
	public setComparedProperties(comparedProperties: string[]) {
		if (!comparedProperties || comparedProperties.length === 0) {
			window.sessionStorage.removeItem(CompareManager.cookie_name);
		} else {
			window.sessionStorage.setItem(CompareManager.cookie_name, comparedProperties.join(','));
		}
		this.onComparedPropertiesChange();
	}

	public addComparedProperty(propertyId: string): boolean {
		const comparedProperties = this.getComparedProperties();
		if (comparedProperties.indexOf(propertyId) <= -1) {
			comparedProperties.push(propertyId);
			this.setComparedProperties(comparedProperties);
			return true;
		}
		return false;
	}

	public removeComparedProperty(propertyId: string): boolean {
		const comparedProperties = this.getComparedProperties();
		const index = comparedProperties.indexOf(propertyId);
		if (index > -1) {
			comparedProperties.splice(index, 1);
			this.setComparedProperties(comparedProperties);
			return true;
		}
		return false;
	}
	public toggleComparedProperty(propertyId: string) {
		if (!this.addComparedProperty(propertyId)) {
			this.removeComparedProperty(propertyId);
		}
	}

	public onComparedPropertiesChange() {
		const comparedProperties = this.getComparedProperties();

		const comparedPropertiesInputs = document.querySelectorAll('input.comparedPropertiesStore');
		const comparedPropertiesRaw = this.getComparedPropertiesRaw();
		for (let i = 0; i < comparedPropertiesInputs.length; i++) {
			(comparedPropertiesInputs.item(i) as HTMLInputElement).value = comparedPropertiesRaw;
		}

		const checkboxes = document.querySelectorAll(CompareManager.comparisonCheckboxSelector);
		for (let i = 0; i < checkboxes.length; i++) {
			const checkbox = checkboxes.item(i);
			const $propertyCard = $(checkbox).parents('.propertyCard');
			const propertyId: string = $propertyCard.data('property-id');
			const isCompared = comparedProperties.indexOf(propertyId) >= 0;
			(checkbox as HTMLInputElement).checked = isCompared;
			if (isCompared) {
				($propertyCard.get(0) as HTMLElement).dataset.propertyIsCompared = 'true';
			} else {
				delete ($propertyCard.get(0) as HTMLElement).dataset.propertyIsCompared;
			}
		}

		const comparisonBar: HTMLElement = document.querySelector('.comparisonBar');
		if (comparedProperties.length === 0) {
			comparisonBar.classList.remove('active');
		}

		const comparisonLinkElement: HTMLAnchorElement = comparisonBar.querySelector('a.btn--compare');
		const comparisonLinkElementHref = comparisonLinkElement.href;
		const firstQuestion = comparisonLinkElementHref.lastIndexOf('?');
		let comparisonLink = firstQuestion !== -1 ? comparisonLinkElementHref.substring(0, firstQuestion + 1) : comparisonLinkElementHref;
		if (comparisonLink.charAt(comparisonLink.length - 1) !== '?') {
			comparisonLink += '?';
		}
		let notFirst = false;
		for (let comparedProperty of comparedProperties) {
			if (notFirst) {
				comparisonLink += '&';
			} else {
				notFirst = true;
			}
			comparisonLink += 'p=' + encodeURIComponent(comparedProperty);
		}
		comparisonLinkElement.href = comparisonLink;

		const comparisonElementsWrapper = comparisonBar.querySelector('.comparisonListing__inner');
		const comparisonElements = comparisonElementsWrapper.querySelectorAll('.comparisonElement');
		const existingComparisonElementIds = {};
		for (let i = 0, slideIndex = 0; i < comparisonElements.length; i++, slideIndex++) {
			const comparisonElement = comparisonElements.item(i);
			const propertyId = comparisonElement.getAttribute('data-property-id');
			if (comparedProperties.indexOf(propertyId) >= 0) {
				// @ts-ignore
				existingComparisonElementIds[propertyId] = 'present';
			} else if (!!comparisonElement.parentElement.removeChild(comparisonElement)) {
				$('.comparisonListing__inner').slick('slickRemove', slideIndex--);
			}
		}

		const properties: any = (window as any).properties;

		// Add elements that are newly being compared
		for (let comparedProperty of comparedProperties) {
			// @ts-ignore
			if (existingComparisonElementIds[comparedProperty] !== 'present') {
				// @ts-ignore
				existingComparisonElementIds[comparedProperty] = 'present';
				let slideContent = '<div><div><div class="comparisonElement" data-property-id="' + comparedProperty + '">';
				const comparisonElementRoot = document.createElement('div');
				comparisonElementRoot.classList.add('comparisonElement');
				comparisonElementRoot.setAttribute('data-property-id', comparedProperty);

				const removeElementFromComparison = document.createElement('span');
				removeElementFromComparison.classList.add('removeComparedProperty');
				removeElementFromComparison.setAttribute('data-property-id', comparedProperty);
				removeElementFromComparison.innerText = 'x';
				slideContent = slideContent + '<span class="removeComparedProperty" data-property-id="' + comparedProperty + '">x</span>';

				const propertyData = properties[comparedProperty];
				comparisonElementRoot.appendChild(removeElementFromComparison);
				comparisonElementRoot.appendChild(CompareManager.getImageFromPropertyId(comparedProperty, propertyData));
				slideContent = slideContent + CompareManager.getImageFromPropertyId(comparedProperty, propertyData).outerHTML;

				const contentElement = document.createElement('div');
				contentElement.classList.add('comparisonElement__content');
				slideContent = slideContent + '<div class="comparisonElement__content">';

				const titleElement = document.createElement('h4');
				titleElement.appendChild(document.createTextNode(propertyData['title']));
				contentElement.appendChild(titleElement);
				slideContent = slideContent + '<h4 class="title">' + propertyData['title'] + '</h4>';

				const addressElement = document.createElement('p');
				addressElement.innerText = propertyData['address'];
				contentElement.appendChild(addressElement);
				slideContent = slideContent + '<p>' + propertyData['address'] + '</p>';
				slideContent = slideContent + '</div>';
				comparisonElementRoot.appendChild(contentElement);
				slideContent = slideContent + '</div></div></div>';

				// comparisonElementsWrapper.appendChild(comparisonElementRoot);
				$('.comparisonListing__inner').slick('slickAdd', slideContent);

				//TODO: Add highlighting for the property and its marker
			}
		}

		if (comparedProperties.length !== 0) {
			comparisonBar.classList.add('active');
			$('.comparisonListing__inner').slick('refresh');
		}

		const refreshMarkerIcons: () => void = (window as any).refreshMarkerIcons;
		if (typeof refreshMarkerIcons === 'function') {
			refreshMarkerIcons();
		}
	}

	private static getCardForPropertyId(propertyId: string): HTMLElement {
		return document.querySelector('.propertyCard[data-property-id="' + propertyId + '"]');
	}

	private static getImageFromPropertyId(propertyId: string, propertyData: any): HTMLElement {
		const propertyCard = CompareManager.getCardForPropertyId(propertyId);
		if (!!propertyCard) {
			const clonedElement = propertyCard.querySelector('.carousel__tabpanel .slide__image').cloneNode(true) as HTMLElement;
			if (clonedElement.getAttribute('style') === null) {
				clonedElement.setAttribute('style', clonedElement.getAttribute('style-lazy'));
				clonedElement.removeAttribute('style-lazy');
			}
			let backgroundImage = clonedElement.style.backgroundImage;
			if (backgroundImage !== null) {
				backgroundImage = backgroundImage.substring(5, backgroundImage.length - 2);
			}
			const img = document.createElement('img');
			img.src = backgroundImage;
			clonedElement.appendChild(img);
			return clonedElement;
		}
		const img = document.createElement('img');
		img.src = propertyData['image'];
		return img as HTMLElement;
	}

	private static getMarkerForPropertyId(propertyId: string): HTMLElement {
		return null; //TODO: Implement this once markers have been added to the map
	}
}

export default new CompareManager();
